import { baseApi } from '@/lib/api/baseApi';
import { accountSetupEndpoints } from './accountSetup.queries';

export const accountSetupApi = baseApi.injectEndpoints({
  endpoints: accountSetupEndpoints,
});

export const { useUpdateCompanyProfileMutation } = accountSetupApi;
